import React from "react";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { useTheme } from "contexts/ThemeContext";

export default function FixedPlugin(props) {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      className="fixed bottom-4 right-4 sm:bottom-[30px] sm:right-[35px] !z-[99] flex h-12 w-12 sm:h-[60px] sm:w-[60px] items-center justify-center rounded-full bg-gradient-to-br from-[#FF7A00] to-[#e66a00] shadow-lg shadow-orange-300/40 p-0"
      onClick={toggleTheme}
      title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
      {...props}
    >
      <div className="cursor-pointer text-white">
        {isDark ? (
          <RiSunFill className="h-5 w-5" />
        ) : (
          <RiMoonFill className="h-5 w-5" />
        )}
      </div>
    </button>
  );
}
